var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCiPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 17.3338V6.66682C5 5.78682 5 5.34682 5.185 5.08682C5.26493 4.9745 5.36722 4.87992 5.48544 4.80902C5.60367 4.73812 5.73527 4.69243 5.872 4.67482C6.189 4.63482 6.577 4.84082 7.352 5.25482L17.352 10.5878L17.356 10.5898C18.213 11.0468 18.642 11.2758 18.783 11.5798C18.905 11.8458 18.905 12.1528 18.783 12.4188C18.642 12.7238 18.212 12.9538 17.353 13.4118L7.353 18.7448C6.576 19.1588 6.189 19.3648 5.873 19.3248C5.7361 19.3073 5.6043 19.2617 5.48589 19.1908C5.36749 19.1199 5.26504 19.0253 5.185 18.9128C5 18.6528 5 18.2138 5 17.3338Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiPlay);
export default __webpack_public_path__ + "static/media/ci_play.f724b17974089f6224d282b2a2e04b20.svg";
export { ForwardRef as ReactComponent };